import React from 'react';
import PropTypes from 'prop-types';
import { GoogleMap } from '@react-google-maps/api';
import { ChildrenType } from '../../propTypes';

const defaultContainerStyle = {
  width: '100%',
  height: '100%',
};

function Map({
  center, zoom, onLoad, onClick, containerStyle, children,
}) {
  return (
    <GoogleMap
      mapContainerStyle={{ ...defaultContainerStyle, ...containerStyle }}
      center={center}
      zoom={zoom}
      onLoad={onLoad}
      onClick={onClick}
      options={{
        fullscreenControlOptions: {
          position: window.google.maps.ControlPosition.TOP_LEFT,
        },
      }}
    >
      {children}
    </GoogleMap>
  );
}

Map.propTypes = {
  center: PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
  }).isRequired,
  zoom: PropTypes.number,
  onLoad: PropTypes.func,
  onClick: PropTypes.func,
  containerStyle: PropTypes.shape({}),
  children: ChildrenType,
};

Map.defaultProps = {
  zoom: 2,
  onLoad: undefined,
  onClick: undefined,
  containerStyle: undefined,
};

// Note: `center`/`zoom` are only the *initial* viewport. Marker focus is handled
// imperatively via the map instance (panTo/fitBounds) so the map animates smoothly
// and does not reset the user's manual pan/zoom on re-render.
export default React.memo(Map);
